/// FOURJS_START_COPYRIGHT(D,2026)
/// Property of Four Js*
/// (c) Copyright Four Js 2026, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ApplicationListPosition4STBehavior", ["StyleBehaviorBase"], function (context, cls) {
  /**
   * Define the applicationListPosition 4ST.
   * Possible values are 'left', 'top'
   * @class ApplicationListPosition4STBehavior
   * @memberOf classes
   * @extends classes.StyleBehaviorBase
   */
  cls.ApplicationListPosition4STBehavior = context.oo.Singleton(cls.StyleBehaviorBase, function ($super) {
    return /** @lends classes.ApplicationListPosition4STBehavior.prototype */ {
      __name: "ApplicationListPosition4STBehavior",

      usedStyleAttributes: ["applicationListPosition"],
      /**
       * @inheritDoc
       */
      _apply: function (controller, data) {
        const node = controller?.getAnchorNode();
        let applicationListPosition = node.getStyleAttribute("applicationListPosition"); // use "left" as default if not specified
        if (!applicationListPosition || cls.WindowHelper.isMobile()) {
          // if no style is set, use default values
          applicationListPosition = context.ApplicationListService.DefaultPosition;
        }
        context.ApplicationListService.setApplicationListPosition(applicationListPosition);
      }
    };
  });
});
